module.exports = __webpack_public_path__ + "img/forchange-logo.bbdea40d.png";